export default __webpack_public_path__ + "static/media/contacts.835639d7.svg";